import {
    ADD_TAG_OPTIONS_MAX,
    ADD_TAG_OPTIONS_MAX_SHORT,
    ADD_TAG_OPTIONS_MAX_SMALL,
    ADD_TAG_ROOMY_WINDOW,
    ADD_TAG_SMALL_WINDOW,
} from './addTagWindow';
import { useMediaQuery } from './useMediaQuery';

/**
 * How many options *Add tag* lists in this window (`addTagWindow.ts`; BUG-203, BUG-206, BUG-255): ten in a window at
 * least `bp/tablet` wide and `ADD_TAG_ROOMY_HEIGHT` tall, seven in any other from `ADD_TAG_SHORT_HEIGHT` tall, and
 * three below that, so the list and the line under it stay in the window with the field at its middle.
 */
export function useAddTagOptionsMax(): number {
    const roomy = useMediaQuery(ADD_TAG_ROOMY_WINDOW);
    const small = useMediaQuery(ADD_TAG_SMALL_WINDOW);
    return roomy ? ADD_TAG_OPTIONS_MAX : small ? ADD_TAG_OPTIONS_MAX_SMALL : ADD_TAG_OPTIONS_MAX_SHORT;
}
